<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">
    <div class="bgc">

    </div>
    <div class="login-con">
      <Card style="width:320px">
        <div style="text-align:center">
          <div class="form-con">
            <h1 class="head1">物联网大数据云平台</h1>
            <h1 class="head2">北京道冲泰科科技有限公司</h1>
            <!-- <h1 class="head2">北京盛科瑞科技有限公司</h1> -->
            <!-- <h1 class="head2">飞纳经纬科技（北京）有限公司</h1> -->
           <login-form @on-success-valid="handleSubmit"></login-form>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import LoginForm from '_c/login-form'
import { mapActions } from 'vuex';
import Lacal from "@/utils/local";
import { setToken } from "@/libs/util";
export default {
  components: {
    LoginForm
  },
  methods: {
    ...mapActions(["handleLogin", "getUserInfo", "getMenuList"]),
    handleSubmit({ username, password }) {
      let data = {
        username: username,
        password: password,
        uuid: "13017c6b-c0c7-42a4-8bf0-426a44b3d052",
        captcha: "3ndfx",
        t: "2018-06-10 10:04:00"
      };
      this.handleLogin(data).then(res => {
        let data = res.data;
        if (data.code === 0) {
          localStorage.setItem("clientId",data.user.clientId);
          localStorage.setItem("userId",data.user.userId);
          this.getMenuList(data.token).then(rest => {
            let date = rest.data;
            if(date.code === 401){
              this.$router.push({
                name: "login"
              });
            }else{
              localStorage.setItem('token',data.token)
              // setToken(data.token)
              this.$router.push({
                name: "home"
              });
            }
          });
        } else {
          Lacal.removeItem('token')
          this.$Message.info("登录失败：" + data.msg);
        }
      });
    }
  }
}
</script>

<style>
.bgc{
  background: url('./login.png');
  background-repeat:no-repeat;
  background-size:100% 100%; 
  width: 100%;
  height: 100%;
  position: absolute;
}
.head1{
  width: 600px;
  position: absolute;
  left:-40%;
  font-size: 60px !important;
  top:-100px;
  color:white;
  text-shadow: 2px 2px 2px yellow
}
.head2{
  width: 600px;
  position: absolute;
  left:-45%;
  font-weight: normal;
  font-size: 18px !important;
  top:232px;
  color:black;
}
</style>
